import type { AxShareConfigModel } from "@/generated/models";
import { joinURL } from "ufo";

export function toCdnUrl(path: string, config: AxShareConfigModel): string {
  if (!config.ClientStaticResourcesCacheUrl) {
    return new URL(path, window.location.href).href;
  }
  return joinURL(config.ClientStaticResourcesCacheUrl, path);
}
